import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HeaderMenu from "./sidebar/headermenu";
import Story from "./story";
import RightWrap from "./rightside/right_wrap";
import EventWrap from "./events/event_wrap";
import { API_STATUS } from "../constants";
import { GetActiveUser } from "../apis/user/get_active_user";
import { reloadState } from "../redux/GlobalSlice";
import SavedEventWrap from "./events/saved_event_wrap";

export default function SavedEvents() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useSelector(state => state.globalstate);

    const [userApi, setUserApi] = useState(API_STATUS);
    const [activeUser, setActiveUser] = useState('');

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        }
    }, []);


    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">
            <div className="">
                <div className="main__inner">
                    <div className="page__heading py-2 md:py-6 mt-2 md:mt-6">
                        <h2 className="text-lg font-bold"> Saved Events </h2>
                    </div>
                    {/* <div onClick={ulogout}>Logout</div> */}
                    <div className="flex max-lg:flex-col xl:gap-10 md:gap-3 md:mt-10" id="js-oversized">
                        <SavedEventWrap />
                        <RightWrap/>
                    </div>
                </div>
            </div>
        </main>
    </div>
}